import type { ISortableMetricMetadata } from '@intelligence/types/common';

const APPANNIE_DATASOURCE = 'appannie';
const MOBILE_DETAILS_OVERLAP_DATASOURCE = 'cross_app';

// 可排序的指标核心配置，配置指标的数据源、指标key、指标的name
export const SORTABLE_METRICS_METADATAS_MAPPING: {
  [metric: string]: ISortableMetricMetadata;
} = {
  cross_app_usage: {
    dataSourceClient: APPANNIE_DATASOURCE,
    dataSource: MOBILE_DETAILS_OVERLAP_DATASOURCE,
    metric: 'cross_app_usage',
    name: 'dbi_overlapanylistis_crossusage',
  },
  cross_affinity: {
    dataSourceClient: APPANNIE_DATASOURCE,
    dataSource: MOBILE_DETAILS_OVERLAP_DATASOURCE,
    metric: 'cross_affinity',
    name: 'dbi_overlapanylistis_crossaffinity',
  },
};

// 可排序指标，宽表根据这个配置 渲染有哪些列，按照这个顺序渲染列
export const SORTABLE_METRICS = ['cross_app_usage', 'cross_affinity'];

export const OVERLAP_STEAM_SUMMARY_METRIC = {
  // 4-segment summary metric
  played_play: ['p&p overlap affinity'],
  played_wishlist: ['p&w overlap affinity'],
  wishlisted_play: ['w&p overlap affinity'],
  wishlisted_wishlist: ['w&w overlap affinity'],
} as any;

// OverlapSteam宽表默认排序指标
export const OVERLAP_STEAM_ORDERMETRIC = {
  // 4-segment order metric
  played_play: 'p&p overlap affinity',
  played_wishlist: 'p&w overlap affinity',
  wishlisted_play: 'w&p overlap affinity',
  wishlisted_wishlist: 'w&w overlap affinity',
} as any;

// OverlapSteam指标参数
export const OVERLAP_STEAM_METRICPARAMS = {
  // 4-segment metric params
  played_play: ['p&p overlap affinity', 'played & play', 'avg_playtime'],
  played_wishlist: ['p&w overlap affinity', 'played & wishlist'],
  wishlisted_play: ['w&p overlap affinity', 'wishlisted & play', 'avg_playtime'],
  wishlisted_wishlist: ['w&w overlap affinity', 'wishlisted & wishlist'],
} as any;

// Summary 卡片list (4-segment summary list，每个 segment 只有一条 summary)
export const SUMMARY_METRIC_LIST = {
  played_play: [
    {
      metricValue: 'p&p overlap affinity',
      textFrontKey: 'dbi_overlapsteam_played_play_front',
      textMiddleKey: 'dbi_overlapsteam_played_play_middle',
      textAfterKey: 'dbi_overlapsteam_played_play_after_pp',
      textEndKey: 'dbi_overlapsteam_played_play_end',
    },
  ],
  played_wishlist: [
    {
      metricValue: 'p&w overlap affinity',
      textFrontKey: 'dbi_overlapsteam_played_wishlist_front',
      textMiddleKey: 'dbi_overlapsteam_played_wishlist_middle',
      textAfterKey: 'dbi_overlapsteam_played_wishlist_after_pw',
      textEndKey: 'dbi_overlapsteam_played_wishlist_end',
    },
  ],
  wishlisted_play: [
    {
      metricValue: 'w&p overlap affinity',
      textFrontKey: 'dbi_overlapsteam_wishlisted_play_front',
      textMiddleKey: 'dbi_overlapsteam_wishlisted_play_middle',
      textAfterKey: 'dbi_overlapsteam_wishlisted_play_after_wp',
      textEndKey: 'dbi_overlapsteam_wishlisted_play_end',
    },
  ],
  wishlisted_wishlist: [
    {
      metricValue: 'w&w overlap affinity',
      textFrontKey: 'dbi_overlapsteam_wishlisted_wishlist_front',
      textMiddleKey: 'dbi_overlapsteam_wishlisted_wishlist_middle',
      textAfterKey: 'dbi_overlapsteam_wishlisted_wishlist_after_ww',
      textEndKey: 'dbi_overlapsteam_wishlisted_wishlist_end',
    },
  ],
} as any;

// pcconsole source list
const SUMMARY_SOURCE_LIST_BASE = [
  [
    'dbi_pcconsole_source_mscience_first',
    'dbi_pcconsole_source_mscience_second',
    'dbi_pcconsole_source_mscience_third',
    'dbi_pcconsole_source_mscience_fourth',
    'dbi_pcconsole_source_mscience_fifth',
  ],
  [
    'dbi_pcconsole_source_alinea_first',
    'dbi_pcconsole_source_alinea_second',
    'dbi_pcconsole_source_alinea_third',
    'dbi_pcconsole_source_alinea_fourth',
    'dbi_pcconsole_source_alinea_fifth',
  ],
  [
    'dbi_pcconsole_source_gamalytic_first',
    'dbi_pcconsole_source_gamalytic_second',
    'dbi_pcconsole_source_gamalytic_third',
    'dbi_pcconsole_source_gamalytic_fourth',
    'dbi_pcconsole_source_gamalytic_fifth',
  ],
  [
    'dbi_pcconsole_source_gsd_first',
    'dbi_pcconsole_source_gsd_second',
    'dbi_pcconsole_source_gsd_third',
    'dbi_pcconsole_source_gsd_fourth',
    'dbi_pcconsole_source_gsd_fifth',
    'dbi_pcconsole_source_gsd_sixth',
    'dbi_pcconsole_source_gsd_seventh',
  ],
  [
    'dbi_pcconsole_source_npd_first',
    'dbi_pcconsole_source_npd_second',
    'dbi_pcconsole_source_npd_third',
    'dbi_pcconsole_source_npd_fourth',
    'dbi_pcconsole_source_npd_fifth',
    'dbi_pcconsole_source_npd_sixth',
    'dbi_pcconsole_source_npd_seventh',
  ],
  [
    'dbi_pcconsole_source_othervendor_first',
    'dbi_pcconsole_source_othervendor_second',
    'dbi_pcconsole_source_othervendor_third',
    'dbi_pcconsole_source_othervendor_fourth',
    'dbi_pcconsole_source_othervendor_fifth',
  ],
];

export const CONSOLE_SOURCE_LIST_BASE = [
  [
    'dbi_pcconsole_source_mscience_first',
    'dbi_pcconsole_source_mscience_second',
    'dbi_pcconsole_source_mscience_third',
    'dbi_pcconsole_source_mscience_fourth',
    'dbi_pcconsole_source_mscience_fifth',
  ],
  [
    'dbi_pcconsole_source_gsd_first',
    'dbi_pcconsole_source_gsd_second',
    'dbi_pcconsole_source_gsd_third',
    'dbi_pcconsole_source_gsd_fourth',
    'dbi_pcconsole_source_gsd_fifth',
    'dbi_pcconsole_source_gsd_sixth',
    'dbi_pcconsole_source_gsd_seventh',
  ],
  [
    'dbi_pcconsole_source_npd_first',
    'dbi_pcconsole_source_npd_second',
    'dbi_pcconsole_source_npd_third',
    'dbi_pcconsole_source_npd_fourth',
    'dbi_pcconsole_source_npd_fifth',
    'dbi_pcconsole_source_npd_sixth',
    'dbi_pcconsole_source_npd_seventh',
  ],
  [
    'dbi_pcconsole_source_othervendor_first',
    'dbi_pcconsole_source_othervendor_second',
    'dbi_pcconsole_source_othervendor_third',
    'dbi_pcconsole_source_othervendor_fourth',
    'dbi_pcconsole_source_othervendor_fifth',
  ],
];

export const SUMMARY_SOURCE_LIST_WITH_DATABRAIN = [
  [
    'dbi_pcconsole_source_databrain_first',
    'dbi_pcconsole_source_databrain_second',
    'dbi_pcconsole_source_databrain_third',
    'dbi_pcconsole_source_databrain_fourth',
    'dbi_pcconsole_source_databrain_fifth',
  ],
  ...SUMMARY_SOURCE_LIST_BASE,
];

export const SUMMARY_SOURCE_LIST = SUMMARY_SOURCE_LIST_BASE;

export const KPI_TRENDS_SUMMARY_SOURCE_LIST = [
  [
    'dbi_pcconsole_source_mscience_first',
    'dbi_pcconsole_source_mscience_second',
    'dbi_pcconsole_source_mscience_third',
    'dbi_pcconsole_source_mscience_fourth',
    'dbi_pcconsole_source_mscience_fifth',
  ],
  [
    'dbi_pcconsole_source_alinea_first',
    'dbi_pcconsole_source_alinea_second',
    'dbi_pcconsole_source_alinea_third',
    'dbi_pcconsole_source_alinea_fourth',
    'dbi_pcconsole_source_alinea_fifth',
  ],
  [
    'dbi_pcconsole_source_gamalytic_first',
    'dbi_pcconsole_source_gamalytic_second',
    'dbi_pcconsole_source_gamalytic_third',
    'dbi_pcconsole_source_gamalytic_fourth',
    'dbi_pcconsole_source_gamalytic_fifth',
  ],
  [
    'dbi_pcconsole_source_gsd_first',
    'dbi_pcconsole_source_gsd_second',
    'dbi_pcconsole_source_gsd_third',
    'dbi_pcconsole_source_gsd_fourth',
    'dbi_pcconsole_source_gsd_fifth',
    'dbi_pcconsole_source_gsd_sixth',
    'dbi_pcconsole_source_gsd_seventh',
  ],
  [
    'dbi_pcconsole_source_databrain_first',
    'dbi_pcconsole_source_databrain_second',
    'dbi_pcconsole_source_databrain_third',
    'dbi_pcconsole_source_databrain_fourth',
    'dbi_pcconsole_source_databrain_fifth',
  ],
  [
    'dbi_pcconsole_source_npd_first',
    'dbi_pcconsole_source_npd_second',
    'dbi_pcconsole_source_npd_third',
    'dbi_pcconsole_source_npd_fourth',
    'dbi_pcconsole_source_npd_fifth',
    'dbi_pcconsole_source_npd_sixth',
    'dbi_pcconsole_source_npd_seventh',
  ],
  [
    'dbi_pcconsole_source_othervendor_first',
    'dbi_pcconsole_source_othervendor_second',
    'dbi_pcconsole_source_othervendor_third',
    'dbi_pcconsole_source_othervendor_fourth',
    'dbi_pcconsole_source_othervendor_fifth',
  ],
];

export const PCCONSOLE_SOURCE_LIST = ['MScience', 'Alinea Analytics', 'Gamalytic', 'GSD', 'NPD', 'Other Vendor'];
export const CONSOLE_SOURCE_LIST = ['MScience', 'GSD', 'NPD', 'Other Vendor'];
export const PCCONSOLE_SOURCE_LIST_WITH_DATABRAIN = ['DataBrain', 'MScience', 'Alinea Analytics', 'Gamalytic', 'GSD', 'NPD', 'Other Vendor'];

export const KPI_TRENDS_PCCONSOLE_SOURCE_LIST = ['MScience', 'Alinea Analytics', 'Gamalytic', 'GSD', 'DataBrain', 'NPD', 'Other Vendor'];
